import React from 'react';
import { Popover } from 'antd';

type HoverQrProps = {
  children: React.ReactNode;
  placement?: 'top' | 'left' | 'right' | 'bottom';
  contentWidth?: number;
};
const HoverQr: React.FC<HoverQrProps> = ({
  children,
  placement = 'top',
  contentWidth = 200,
}) => {
  const content = (
    <div style={{ width: contentWidth }}>
      <img
        src={"https://static.soyoung.com/sy-pre/wechatimg3795-1760681400632.png"}
        alt="企业微信二维码"
        style={{ width: '100%', height: 'auto', display: 'block', borderRadius: 8 }}
      />
      <div style={{ marginTop: 8, textAlign: 'center', color: '#666' }}>微信扫码咨询</div>
    </div>
  );

  return (
    <Popover
      placement={placement}
      content={content}
      trigger={["hover"]}
      getPopupContainer={() => document.body}
    >
      <span>{children}</span>
    </Popover>
  );
};

export default HoverQr;


